export default __webpack_public_path__ + "static/media/property_196.a36eb19d.png";